"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VDIOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VDIOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 16,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.788 4.824 9.5H3.736L2.168 3.788h1L4.04 7.26c.032.112.061.243.088.392.032.15.061.299.088.448.032.144.053.275.064.392.016-.117.037-.248.064-.392l.096-.448c.032-.15.061-.28.088-.392l.88-3.472H6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.81 6.564c0 .64-.096 1.179-.288 1.616-.186.432-.461.76-.824.984-.357.224-.8.336-1.328.336H7.002V3.788h1.472c.496 0 .918.107 1.264.32.347.208.611.517.792.928.187.41.28.92.28 1.528Zm-.992.04c0-.453-.053-.827-.16-1.12-.101-.293-.253-.51-.456-.648-.197-.144-.445-.216-.744-.216h-.496v4.048h.416c.491 0 .854-.17 1.088-.512.235-.347.352-.864.352-1.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.463 9.5h2.112v-.536l-.576-.208V4.532l.576-.208v-.536h-2.112v.536l.576.208v4.224l-.576.208V9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H9v2h3.5a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1H7v-2H2a2 2 0 0 1-2-2V3Zm2-1h12a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VDIOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VDIOutline;
exports["default"] = _default;